import React from 'react';
import './Scenario2.css';
import ReactPlayer from 'react-player';

const Scenario2Video2 = () => {
    return (
        <div className='Scenario1VideoWrap'>
            <ReactPlayer url='https://youtu.be/o-6Rmxc3-Ak' controls={true} />
        </div>
    );
}

export default Scenario2Video2;